import type { App } from 'vue'
import { globalComponentsPlugin } from '@oatsovernight/storybook'

export const storybookPlugin = {
  install(app: App) {
    app.use(globalComponentsPlugin)
  }
}

export default storybookPlugin
